import { render, staticRenderFns } from "./ServerExcelDownloadIframe.vue?vue&type=template&id=83fe3abe&"
import script from "./ServerExcelDownloadIframe.vue?vue&type=script&lang=ts&"
export * from "./ServerExcelDownloadIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports